//
// StackNavigationControl.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../../lib";
import "../../../BIRDModel";
import "@sas-dvr/ltjs-commons/styles/ButtonType";
import "./ButtonDirection";
import "@sas-dvr/ltjs-commons/styles/HorizontalPosition";
import "@sas-dvr/ltjs-commons/styles/VerticalPosition";

var StackNavigationControl = createModule("BIRD::StackNavigationControl", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        verticalPosition: 4,
        buttonType: 4,
        horizontalPosition: 4,
        buttonDirection: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default StackNavigationControl;
